module.exports = __webpack_public_path__ + "static/media/close.0c69ab3e.svg";